import React from 'react';
import PropTypes from 'prop-types';
import DayMonthYearInputContainer from '../../../redux/containers/DayMonthYearInputContainer';
import DayMonthYearErrorContainer from '../../../redux/containers/DayMonthYearErrorContainer';
import './DayMonthYear.scss';
import ValidRanges from '../../../common/validation/ValidRanges';

const MonthYear = (props) => {
  const { name, ...rest } = props;
  const { label, autoTestClass, required } = rest;
  return (
    <div className="form-input-container relative">
      <label htmlFor={name}>{label}</label>
      {required && <span className="form-required-text">*</span>}
      <div className="month-year-container">
        <div className="day-month-year-month">
          <DayMonthYearInputContainer
            className={`${autoTestClass}-month`}
            name={`${name}Month`}
            placeholder="MM"
            min={ValidRanges.MIN_MONTH}
            max={ValidRanges.MAX_MONTH}
            maxLength={2}
            {...rest}
          />
        </div>
        <div className="day-month-year-year">
          <DayMonthYearInputContainer
            className={`${autoTestClass}-year`}
            name={`${name}Year`}
            placeholder="YYYY"
            min={ValidRanges.MIN_YEAR}
            max={ValidRanges.MAX_YEAR}
            maxLength={4}
            {...rest}
          />
        </div>
      </div>
      <div className="day-month-year-error-container">
        <div>
          <DayMonthYearErrorContainer
            name={`${name}Month`}
            {...rest}
          />
        </div>
        <div>
          <DayMonthYearErrorContainer
            name={`${name}Year`}
            {...rest}
          />
        </div>
      </div>
    </div>);
};

MonthYear.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  autoTestClass: PropTypes.string
};

export default MonthYear;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/DayMonthYear/MonthYear.js
 **/